import { AbilityTuple, MongoAbility, MongoQuery } from "@casl/ability";
import { useStaff } from "@gymflow/api";
import { ReactNode, useContext, useEffect, useState } from "react";

import { LoadingPortal } from "../components/pages/LoadingPortal";
import { AbilityContext, create, update } from "../permissions";
import useGymflowModels from "../store";
import { Unauthorized } from "../views/Unauthorized";
import { AuthenticationContext } from "./authentication/AuthenticationContext";
import { useClubSettings } from "./settings";

export function StaffPermissionsProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { userId } = useContext(AuthenticationContext);
  const { api } = useGymflowModels();
  const staffQuery = useStaff({
    api: api,
    staffId: userId as string,
  });

  const { club } = useClubSettings();

  const [ability, setAbility] =
    useState<MongoAbility<AbilityTuple, MongoQuery>>();

  useEffect(() => {
    if (staffQuery.isSuccess && staffQuery.data) {
      if (ability) {
        update({
          ability,
          role: staffQuery.data.role,
          userId: userId as string,
          stripeAccountType: club.stripeAccountType,
        });
      } else {
        setAbility(
          create({
            role: staffQuery.data.role,
            userId: userId as string,
            stripeAccountType: club.stripeAccountType,
          }),
        );
      }
    }
  }, [
    ability,
    setAbility,
    staffQuery.data,
    staffQuery.isSuccess,
    club.stripeAccountType,
    userId,
  ]);
  if (staffQuery.isError) {
    return <Unauthorized />;
  }
  if (!ability) {
    return <LoadingPortal message="Processing user permissions..." />;
  }

  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  );
}
